import { render, staticRenderFns } from "./notifyStats.vue?vue&type=template&id=212d6632&scoped=true&lang=pug"
import script from "./notifyStats.vue?vue&type=script&lang=js"
export * from "./notifyStats.vue?vue&type=script&lang=js"
import style0 from "./notifyStats.vue?vue&type=style&index=0&id=212d6632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d6632",
  null
  
)

export default component.exports